import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable()
export class FeatureVideoAnalytics extends AnalyticsBase {
  public readonly namespace = 'FeatureVideo';
  public readonly requireViewContext = true;

  public trackOpenVideo(featureName: string) {
    this.track('OpenVideo', { featureName });
  }

  public trackCloseInfobox(featureName: string) {
    this.track('CloseInfobox', { featureName });
  }
}
